import React from "react";

export function Navbar() {
    return (
      <nav>
        <ul>
          <li><a href="/">Home</a></li>
          <li><a href="/about">About Me</a></li>
          <li><a href="/resume">Resume</a></li>
          <li><a href="/projects">Projects</a></li>
          <li><a href="/certifications">Certifications</a></li>
        </ul>
      </nav>
    );
  }